import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/Icons/info.svg'


const _withScopeId = n => (_pushScopeId("data-v-d4f76146"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 0,
  class: "insights-engagement-theme-item-info-icon"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "info"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "insights-engagement-theme-info" }
const _hoisted_6 = { class: "left" }
const _hoisted_7 = { class: "points" }
const _hoisted_8 = { class: "delta-div" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Overall Score:", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "vs previous:", -1))
const _hoisted_11 = { class: "right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Typography = _resolveComponent("Typography")!
  const _component_InsightsDetailRow = _resolveComponent("InsightsDetailRow")!
  const _component_UpDownArrow = _resolveComponent("UpDownArrow")!
  const _component_InsightsGraph = _resolveComponent("InsightsGraph")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
            'desktop-insights-engagement-theme-item': !_ctx.$isMobile,
            select: _ctx.desktopEngagementThemeSelected === _ctx.themeId,
        }),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateSelectedTheme(_ctx.themeId)))
  }, [
    _createVNode(_component_InsightsDetailRow, {
      class: _normalizeClass(['insights-detail-row', { mobile: _ctx.$isMobile }])
    }, {
      icon: _withCtx(() => [
        _createElementVNode("img", {
          src: _ctx.engagementIcon(_ctx.themeId),
          class: "icon",
          alt: "icon"
        }, null, 8, _hoisted_1)
      ]),
      title: _withCtx(() => [
        _createVNode(_component_Typography, {
          variant: "subtitle1",
          class: "insights-engagement-theme-item-title"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, _toDisplayString(_ctx.title), 1),
            (_ctx.showInfoIcon)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
              : _createCommentVNode("", true)
          ], undefined, true),
          _: 1
        })
      ]),
      subtitle: _withCtx(() => [
        _createVNode(_component_Typography, {
          variant: "caption",
          class: "subtitle"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.tileDescription(_ctx.themeId)), 1)
          ], undefined, true),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["class"]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_UpDownArrow, { positive: _ctx.deltaPositive }, null, 8, ["positive"])
          ]),
          _createVNode(_component_Typography, { variant: "h4" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(Math.abs(Math.round(_ctx.points))), 1)
            ], undefined, true),
            _: 1
          })
        ]),
        _createVNode(_component_Typography, { variant: "caption" }, {
          default: _withCtx(() => [
            _hoisted_9,
            _createTextVNode(" " + _toDisplayString(Math.round(_ctx.overallScore)) + "%", 1)
          ], undefined, true),
          _: 1
        }),
        _createVNode(_component_Typography, { variant: "caption" }, {
          default: _withCtx(() => [
            _hoisted_10,
            _createTextVNode(" " + _toDisplayString(Math.round(_ctx.previousScore)) + "%", 1)
          ], undefined, true),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_11, [
        (_ctx.chartData)
          ? (_openBlock(), _createBlock(_component_InsightsGraph, {
              key: 0,
              color: _ctx.getGraphColour(_ctx.themeId, _ctx.$palette),
              data: _ctx.chartData,
              height: 60
            }, null, 8, ["color", "data"]))
          : (_openBlock(), _createBlock(_component_InsightsGraph, {
              key: 1,
              color: _ctx.$palette.neutral,
              data: [1, 1],
              height: 60
            }, null, 8, ["color"]))
      ])
    ]),
    (!_ctx.$isMobile)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(`desktop-chevron ${
                _ctx.desktopEngagementThemeSelected === _ctx.themeId && 'selected'
            }`)
        }, [
          _createVNode(_component_FontAwesomeIcon, {
            class: "right-chevron-icon",
            icon: _ctx.faChevronRight
          }, null, 8, ["icon"])
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
}